"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ToasterNotification {
    static setOptions(event, timer, message, preventDuplicates = true, positionClass = 'toast-top-right', closeButton = false) {
        try {
            toastr.options = {
                "closeButton": closeButton,
                "closeHtml": "<button><i class=\"icon-off\"><\/i><\/button>",
                "closeClass": "toast-close-button",
                "closeDuration": 300,
                "closeEasing": "swing",
                "closeMethod": "fadeOut",
                "debug": false,
                "newestOnTop": true,
                "progressBar": true,
                "positionClass": positionClass,
                "preventDuplicates": preventDuplicates,
                "rtl": true,
                "onclick": null,
                "showDuration": 400,
                "hideDuration": 5000,
                "timeOut": timer * 1000,
                "extendedTimeOut": 2500,
                "showEasing": "linear",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut"
            };
            toastr[event]("<b class='fof-14'>" + message + "</b>");
        }
        catch (e) {
            return false;
        }
    }
    static success(timer, message, preventDuplicates = true, positionClass = 'toast-top-right', closeButton = false) {
        ToasterNotification.setOptions('success', timer, message, preventDuplicates, positionClass, closeButton);
    }
    static error(timer, message, preventDuplicates = true, positionClass = 'toast-top-right', closeButton = false) {
        ToasterNotification.setOptions('error', timer, message, preventDuplicates, positionClass, closeButton);
    }
    static info(timer, message, preventDuplicates = true, positionClass = 'toast-top-right', closeButton = false) {
        ToasterNotification.setOptions('info', timer, message, preventDuplicates, positionClass, closeButton);
    }
    static warning(timer, message, preventDuplicates = true, positionClass = 'toast-top-right', closeButton = false) {
        ToasterNotification.setOptions('warning', timer, message, preventDuplicates, positionClass, closeButton);
    }
}
exports.default = ToasterNotification;
